import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#1C2735' },
    secondary: { main: '#F9AA33' },
    background: { default: '#1C2735', paper: '#283144' },
    text: { primary: '#fff', secondary: '#F9AA33' },
    divider: 'rgba(255,255,255,0.07)',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: 'Inter, Roboto, Arial, sans-serif',
    h6: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h4: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    h2: { fontWeight: 500 },
    h1: { fontWeight: 500 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#283144',
          color: '#fff',
          border: '1px solid #232f3e',
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#283144',
          color: '#fff',
          border: '1px solid #232f3e',
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#283144',
          color: '#fff',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          backgroundColor: '#283144',
          color: '#fff',
          borderColor: '#2c2c2c',
        },
        head: {
          color: '#fff',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(even)': {
            backgroundColor: '#283144',
          },
          '&:nth-of-type(odd)': {
            backgroundColor: '#232f3e',
          },
          '&:hover': {
            backgroundColor: '#232f3e',
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255,255,255,0.07)',
        },
      },
    },
  },
});

export default theme; 